


















































import { Component, Vue } from "vue-property-decorator";
import { Constants, Console, Events, Language } from "@/common/global.ts";

import BaseView from "@/common/base-page.ts";

@Component
export default class ShareModal extends BaseView {

    /**
     * [signUrl description]
     *
     * @type {[type]}
     */
    public signUrl: string = "";

    /**
     * [signUrlVertical description]
     *
     * @type {[type]}
     */
    public signUrlVertical: string = "";

    /**
     * [mounted description]
     *
     * @return {[type]} [description]
     */
    public mounted() {
        super.mounted();
        const sign: string = window.nao_astrologicalSign || "cancer";
        let zip: string = "";
        if ( window.isMobile.apple.device ) {
            zip = "&zip=true";
        }
        this.signUrl = [
            window.location.origin,
            "/download?sign=",
            sign.toLowerCase(),
            zip,
        ].join("");
        this.signUrlVertical = [
            window.location.origin,
            "/download?sign=",
            sign.toLowerCase(),
            zip,
            "&format=vertical",
        ].join("");
    }

    /**
     * [service description]
     *
     * @type {[type]}
     */
    public ShareTo(service: string): void {
        const sign = window.nao_astrologicalSign.toLowerCase();
        const shareUrl: string = `${window.location.origin}/player/share.php?sign=${sign}`;
        // const shareUrl: string = Language.SHARE_URL + window.nao_astrologicalSign;
        const shareBody: string = this.getShareString(service);
        const shareHashtag: string = Language.SHARE_HASHTAG;

        switch (service) {

            case Constants.SOCIAL_FACEBOOK:
                this.ShareFacebook(shareUrl, shareBody, shareHashtag);
                break;

            case Constants.SOCIAL_TWITTER:
                this.ShareTwitter(shareUrl, shareBody, shareHashtag);
                break;

        }
    }

    /**
     * open
     */
    public open(): void {
        const modal: HTMLDivElement = <HTMLDivElement> this.$refs.ShareModal;
        modal.classList.add("active");
    }

    /**
     * close
     */
    public close(): void {
        const modal: HTMLDivElement = <HTMLDivElement> this.$refs.ShareModal;
        modal.classList.remove("active");
    }

    /**
     * get share string
     */
    private getShareString(service: string): string {
        let x = "a";
        switch (window.nao_astrologicalSign) {
            case "Aries": {
                x = "an";
                break;
            }
            case "Aquarius": {
                x = "an";
                break;
            }
            default: {
                break;
            }
        }
        if ( service === "Twitter") {
            return [
                "I%27m%20",
                x,
                "%20",
                window.nao_astrologicalSign,
                "%20in%20%23OrbitByNAO.%20Experience%20this%20interactive%20",
                "music%20video%20inspired%20by%20your%20Saturn%20Return%20and",
                "%20powered%20by%20%40Microsoft%20AI",
            ].join("");
        } else {
            return [
                "I'm ",
                x,
                window.nao_astrologicalSign,
                " in #OrbitByNAO. Experience this interactive music video inspired",
                " by your Saturn Return and powered by Microsoft AI",
            ].join("");
        }
    }


    // Sharing Methods
    // -----------------------------------------------------------------

    /**
     * ShowSignupWindow
     */
    private ShowSignupWindow(): void {
        return;
    }

    /**
     * Facebook
     */
    private ShareFacebook(url: string, body: string, hashtag: string): void {
        window.FB.ui({
            method: "share",
            href: url,
            hashtag: "#" + hashtag,
            quote: body,
        }, (res: any) => {
            this.ShowSignupWindow();
        });
    }

    /**
     * Twitter
     */
    private ShareTwitter(url: string, body: string, hashtag: string): void {
        // window.addEventListener("focus", this.ShowSignupWindow);

        const locationHref: string = [
            "https://twitter.com/intent/tweet/?text=",
            body,
            "&via=thisNAO&url=",
            url,
        ].join("");

        const options: string = [
            "toolbar=no",
            "location=no",
            "status=no",
            "menubar=no",
            "scrollbars=no",
            "resizeable=yes",
            "width=800",
            "height=450",
        ].join(",");

        // Trigger the Twitter share dialog
        window.open(locationHref, "targetWindow", options);
    }


    // Event Handlers
    // -----------------------------------------------------------------

    private Handle_OnClickClose(e: MouseEvent): void {
        e.preventDefault();

        this.close();
    }

}
